<template>
  <div>
    <div class="table-responsive col-lg-12">
      <aDataTable :data="orders">
        <template #columns>
          <tr>
            <th>Name</th>
            <th>Links</th>
            <th>Client</th>
            <th>Group</th>
            <th>Added</th>
            <th>Deadline</th>
          </tr>
        </template>
        <template #rows>
          <tr v-for="order in orders" :key="order.id">
            <td>
              <i class="fa fa-check green" v-if="order.status === 'completed'" v-tooltip="'Completed'"></i>
              <i class="fa fa-clock orange" v-else v-tooltip="order.status"></i>
              <router-link :to="'/pbn/link-order/' + order.id ">{{ order.name }}</router-link>
            </td>
            <td>{{ order.linksCompleted }} / {{ order.number }}</td>
            <td>{{ order.client.name }}</td>
            <td>{{ order.group ? order.group.name : '/' }}</td>
            <td>{{ $moment(order.added.date).format('DD.MM.') }}</td>
            <td></td>
          </tr>
        </template>
      </aDataTable>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      orders: 'getLinkOrders'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Links/Orders/List.vue